import React, { Component } from "react";
import Menu from "./includes/Menu";
import { Grid } from "../../../node_modules/@material-ui/core";

const lang = "";

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.lang = props.lang ? props.lang : "";
  }

  componentDidMount() {
    document.title = this.getLangText({
      tc: "私隱政策",
      sc: "私隐政策",
      en: "Privacy Policy "
    });
  }

  getLangText(langJson) {
    return this.lang ? langJson[this.lang] : langJson["tc"];
  }

  render() {
    return PrivacyPolicyJSX(this);
  }
}

const PrivacyPolicyJSX = ctx => (
  <div className={ctx.lang === "en" ? "en" : ""}>
    <Menu lang={ctx.lang} />

    <div className="main-content-container">
      <div className="main-content-inner-wrapper privacy-policy">
        <Grid container spacing={0}>
          <Grid item id="page-title">
            <span>
              {ctx.getLangText({
                tc: "私隱政策",
                sc: "私隐政策",
                en: "Privacy Policy"
              })}
            </span>
          </Grid>
        </Grid>
        <div style={{ clear: "both" }} />
        <Grid container spacing={0}>
          <Grid item id="grid-section" xs={12}>
            <p>
              {ctx.getLangText({
                tc: `匯寶資本集團(「匯寶資本」)一直致力為客戶提供最佳之服務。`,
                sc: `汇宝资本集团(「汇宝资本」)一直致力为客户提供最佳之服务。`,
                en: `FxHB Group Company Limited ( "FxHB Group" ) wants to provide the best service possible to FxHB Group's clients.`
              })}
            </p>

            <p>
              {ctx.getLangText({
                tc: `要達到此一目的，其中一個途徑就是利用客戶的資料，為客戶提供最方便的途徑，獲得合適的產品和服務，匯寶資本亦明白到客戶對於其個人資料的使用非常關注。`,
                sc: `要达到此一目的，其中一个途径就是利用客户的数据，为客户提供最方便的途径，获得合适的产品和服务，汇宝资本亦明白到客户对于其个人资料的使用非常关注。`,
                en: `One way that FxHB Group does this is by using client information to provide FxHB Group's clients with convenient access to the right products and services. FxHB Group also recognizes that FxHB Group's clients have important expectations regarding the use of that information.`
              })}
            </p>

            <p>
              {ctx.getLangText({
                tc: `保護客戶資料乃是匯寶資本一直認真處理的事項。`,
                sc: `保护客户数据乃是汇宝资本一直认真处理的事项。`,
                en: `Safeguarding client information is a matter that FxHB Group takes seriously. That is why FxHB Group has set forth the following principles to affirm FxHB Group's long-standing commitment to confidentiality:`
              })}
            </p>
          </Grid>

          <Grid item id="grid-section" xs={12}>
            <h1>
              {ctx.getLangText({
                tc: `因此，匯寶資本訂立了以下守則，矢志承諾對客戶的資料保密：`,
                sc: `因此，汇宝资本订立了以下守则，矢志承诺对客户的资料保密：`,
                en: `From time to time, it is necessary for clients who are individuals to supply FxHB Group with data which are personal data ("Data") for the purposes of the Personal Data (Privacy) Ordinance (Cap. 486 of the laws of Hong Kong).`
              })}
            </h1>

            <ul>
              <li>
                {ctx.getLangText({
                  tc: `無論任何時候，個人名義的客戶均需要向匯寶資本提供個人資料(「資料」)，以作個人資料(私隱)條例(《香港法例》第486章)下之用途。有關客戶的資料(或其他資料)可能用於以下用途：`,
                  sc: `无论任何时候，个人名义的客户均需要向汇宝资本提供个人资料(「数据」)，以作个人资料(私隐)条例(《香港法例》第486章)下之用途。有关客户的数据(或其他数据)可能用于以下用途：`,
                  en: `The purposes for which Data (and other information) relating to clients may be used are as follows:`
                })}
              </li>
              <ul>
                <li>
                  {ctx.getLangText({
                    tc: `向客戶提供之服務及設施之日常運作；`,
                    sc: `向客户提供之服务及设施之日常运作；`,
                    en: `the daily operation of the services and facilities provided to clients;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `進行信貸審查；`,
                    sc: `进行信贷审查；`,
                    en: `conducting credit checks;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `協助其他機構進行信貸審查；`,
                    sc: `协助其他机构进行信贷审查；`,
                    en: `assisting other institutions to conduct credit checks;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `確保客戶的信用維持良好；`,
                    sc: `确保客户的信用维持良好；`,
                    en: `ensuring clients' ongoing credit worthiness;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `設計供客戶使用之金融服務或相關產品；`,
                    sc: `设计供客户使用之金融服务或相关产品；`,
                    en: `designing financial services or related products for clients' use;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `向客戶推廣金融服務及相關產品；`,
                    sc: `向客户推广金融服务及相关产品；`,
                    en: `marketing financial services or related products to clients;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `釐定拖欠客戶或客戶拖欠之債務金額；`,
                    sc: `厘定拖欠客户或客户拖欠之债务金额；`,
                    en: `determining the amount of indebtedness owed to or by clients;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `根據任何法例或規例之規定，符合作出披露之要求；及`,
                    sc: `根据任何法例或规例之规定，符合作出披露之要求；及`,
                    en: `meeting the requirements to make disclosure under the requirements of any law or regulations; and`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `與任何前述部份有關之任何用途。`,
                    sc: `与任何前述部份有关之任何用途。`,
                    en: `any purposes relating to any of the foregoing.`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `匯寶資本持有之客戶有關的資料(及其他資料)將會保密，但匯寶資本可向以下人士披露所有資料(及其他資料)，而客戶同意披露所有資料(及其他資料)亦是匯寶資本向客戶提供服務、產品及資料之條件：`,
                    sc: `汇宝资本持有之客户有关的数据(及其他数据)将会保密，但汇宝资本可向以下人士披露所有数据(及其他数据)，而客户同意披露所有数据(及其他数据)亦是汇宝资本向客户提供服务、产品及数据之条件：`,
                    en: `Data (and other information) held by FxHB Group relating to clients will be kept confidential but FxHB Group may disclose, and it is a condition of FxHB Group providing services, products and information to clients that each client consents to the disclosure of, all Data (and other information) to:`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `任何向匯寶資本提供有關其業務運作之行政、信貸資料、債務追討、電訊、電腦、繳款或其他服務之高級職員、僱員、代理、承包商或第三者；`,
                    sc: `任何向汇宝资本提供有关其业务运作之行政、信贷数据、债务追讨、电讯、计算机、缴款或其他服务之高级职员、雇员、代理、承包商或第三者；`,
                    en: `any officer, employee, agent, contractor or third party who provides administrative, credit information, debt collection, telecommunications, computer, payment or other services to FxHB Group in connection with the operation of their business;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `客戶已有或擬與之進行交易之任何金融機構；`,
                    sc: `客户已有或拟与之进行交易之任何金融机构；`,
                    en: `any financial institution with which the client has or proposes to have dealings;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `監管當局及其他有關政府機構；`,
                    sc: `监管当局及其他有关政府机构；`,
                    en: `regulatory authorities and other relevant government bodies;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `任何有責任為匯寶資本保密之其他人士，包括匯寶資本以內承諾保持此等資料機密之公司；`,
                    sc: `任何有责任为汇宝资本保密之其他人士，包括汇宝资本以内承诺保持此等资料机密之公司；`,
                    en: `any other person under a duty of confidentiality to FxHB Group including a company within FxHB Group which has undertaken to keep such information confidential;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `匯寶資本系內公司之間對客戶之資料使用，須依據嚴格之內部安全標準、保密政策及適用法律；`,
                    sc: `汇宝资本系内公司之间对客户之数据使用，须依据严格之内部安全标准、保密政策及适用法律；`,
                    en: `FxHB Group shares information regarding clients among FxHB Group only in accordance with strict internal security standards and confidentiality policies and with applicable law;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `匯寶資本約束僱員完全遵守該等標準、政策及法律；`,
                    sc: `汇宝资本约束雇员完全遵守该等标准、政策及法律；`,
                    en: `FxHB Group holds FxHB Group's employees fully accountable for adhering to those standards, policies and laws;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `除為了進行業務、遵守適用法律、保護免受欺詐或作出匯寶資本認為可能符合客戶利益之產品及服務優惠外，匯寶資本不會將有關客戶的資料分發予其他公司`,
                    sc: `除为了进行业务、遵守适用法律、保护免受欺诈或作出汇宝资本认为可能符合客户利益之产品及服务优惠外，汇宝资本不会将有关客户的资料分发予其他公司`,
                    en: `FxHB Group does not share information about FxHB Group's clients with other companies except in order to conduct FxHB Group's business, comply with applicable law, protect against fraud or make available special offers of products and services that FxHB Group feel may be of interest to FxHB Group's clients;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `匯寶資本亦可依據適用法律向監管當局及執法人員提供資料；及`,
                    sc: `汇宝资本亦可依据适用法律向监管当局及执法人员提供资料；及`,
                    en: `FxHB Group may also provide information to regulatory authorities and law enforcement officials in accordance with applicable law; and`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `匯寶資本訂立了極高標準，以保護客戶的資料免受未經授權之更改或破壞。`,
                    sc: `汇宝资本订立了极高标准，以保护客户的数据免受未经授权之更改或破坏。`,
                    en: `FxHB Group has established high standards for protecting information regarding FxHB Group's clients from unauthorized alteration or destruction.`
                  })}
                </li>
              </ul>
            </ul>
          </Grid>

          <Grid item id="grid-section" xs={12}>
            <h1>
              {ctx.getLangText({
                tc: `匯寶資本可依據個人資料(私隱)條例及其他適用法律進行以下活動：`,
                sc: `汇宝资本可依据个人资料(私隐)条例及其他适用法律进行以下活动：`,
                en: `FxHB Group may, in accordance with the Personal Data (Privacy) Ordinance and any other applicable law:`
              })}
            </h1>
            <ul>
              <li>
                {ctx.getLangText({
                  tc: `將客戶提供或有關客戶之任何資料或其他資料，與匯寶資本或任何其他人士持有之資料 (或其他資料)進行配對、比較或交換，以作以下用途：`,
                  sc: `将客户提供或有关客户之任何数据或其他数据，与汇宝资本或任何其他人士持有之数据 (或其他数据)进行配对、比较或交换，以作以下用途：`,
                  en: `match, compare or exchange any Data or other information provided by, or in respect of, a client with Data (or other information) held by FxHB Group or any other person for the purpose of:`
                })}
              </li>
              <ul>
                <li>
                  {ctx.getLangText({
                    tc: `信貸審查；`,
                    sc: `信贷审查；`,
                    en: `credit checking;`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `資料(或其他資料)核對；及`,
                    sc: `数据(或其他数据)核对；及`,
                    en: `Data (and other information) verification; and`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `提出或核對資料(或其他資料)，該等資料可能用於在任何時候採取對客戶或任何其他人士不利的行動。`,
                    sc: `提出或核对数据(或其他数据)，该等数据可能用于在任何时候采取对客户或任何其他人士不利的行动。`,
                    en: `otherwise producing or verifying Data (and other information) which may be used for the purpose of taking adverse action against the client or any other person at any time.`
                  })}
                </li>
                <li>
                  {ctx.getLangText({
                    tc: `將此等資料(或其他資料)轉往香港以外任何地方(不論在香港以外處理、持有或使用此等資料(或其他資料)。`,
                    sc: `将此等数据(或其他数据)转往香港以外任何地方(不论在香港以外处理、持有或使用此等数据(或其他数据)。`,
                    en: `transfer such Data (and other information) to any place outside Hong Kong (whether for the processing, holding or use of such Data (and other information) outside Hong Kong).`
                  })}
                </li>
              </ul>
            </ul>
          </Grid>

          <Grid item id="grid-section" xs={12}>
            <h1>
              {ctx.getLangText({
                tc: `根據及依據個人資料(私隱)條例之條款，每位客戶均有權：`,
                sc: `根据及依据个人资料(私隐)条例之条款，每位客户均有权：`,
                en: `Under and in accordance with the terms of the Personal Data (Privacy) Ordinance each client has a right to:`
              })}
            </h1>
            <ul>
              <li>
                {ctx.getLangText({
                  tc: `檢查匯寶資本是否持有有關客戶之資料，及是否有權使用此等資料；`,
                  sc: `检查汇宝资本是否持有有关客户之数据，及是否有权使用此等数据；`,
                  en: `check whether FxHB Group holds Data about the client and the right of access to such Data;`
                })}
              </li>
              <li>
                {ctx.getLangText({
                  tc: `要求匯寶資本更改有關客戶之任何錯誤資料；`,
                  sc: `要求汇宝资本更改有关客户之任何错误资料；`,
                  en: `require FxHB Group to correct any Data relating to the client which is inaccurate;`
                })}
              </li>
              <li>
                {ctx.getLangText({
                  tc: `確定匯寶資本有關資料之政策及做法，以及獲知匯寶資本持有有關客戶之個人資料種類；及`,
                  sc: `确定汇宝资本有关资料之政策及做法，以及获知汇宝资本持有有关客户之个人资料种类；及`,
                  en: `ascertain FxHB Group's policies and practices in relation to Data and to be informed of the kind of personal data relating to the client held by FxHB Group; and`
                })}
              </li>
              <li>
                {ctx.getLangText({
                  tc: `要求匯寶資本停止使用有關客戶之個人資料作為直接推廣之用途。`,
                  sc: `要求汇宝资本停止使用有关客户之个人资料作为直接推广之用途。`,
                  en: `request FxHB Group to cease using Data about the client for direct marketing purpose.`
                })}
              </li>
            </ul>
          </Grid>

          <Grid item id="grid-section" xs={12}>
            <p>
              {ctx.getLangText({
                tc: `依據個人資料(私隱)條例之條款，匯寶資本有權就處理任何資料索取查閱之申請收取合理費用。`,
                sc: `依据个人资料(私隐)条例之条款，汇宝资本有权就处理任何数据索取查阅之申请收取合理费用。`,
                en: `In accordance with the terms of the Personal Data (Privacy) Ordinance, FxHB Group has the right to charge a reasonable fee for the processing of any Data access request.`
              })}
            </p>
            <p>
              {ctx.getLangText({
                tc: `在匯寶資本有關客戶之資料只會用於進行本身業務的合法用途，以提供優質服務，及進行產品設計及優惠，從而顯示匯寶資本明白客戶及其需要。`,
                sc: `在汇宝资本有关客户之数据只会用于进行本身业务的合法用途，以提供优质服务，及进行产品设计及优惠，从而显示汇宝资本明白客户及其需要。`,
                en: `At FxHB Group, information regarding FxHB Group's clients is used solely in the legitimate conduct of FxHB Group's business, to deliver superior service and to design products and special offers that demonstrate FxHB Group's understanding of clients and client's needs.`
              })}
            </p>
            <p>
              {ctx.getLangText({
                tc: `隨著匯寶資本會在新科技年代進一步發展新產品和服務，匯寶資本會繼續竭力確保客戶的資料會被正確使用及受到適當保護。`,
                sc: `随着汇宝资本会在新科技年代进一步发展新产品和服务，汇宝资本会继续竭力确保客户的数据会被正确使用及受到适当保护。`,
                en: `As FxHB Group moves forward in developing new products and services in an era of vast technological change, FxHB Group will continue to maintain FxHB Group's dedication to assuring that client information is properly used and appropriately safeguarded.`
              })}
            </p>
          </Grid>
        </Grid>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/pages/PrivacyPolicy.js